import(/* webpackMode: "eager" */ "/home/runner/_work/hg-client/hg-client/apps/web/public/images/heros/404.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/hg-client/hg-client/apps/web/src/components/NextImage.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/hg-client/hg-client/apps/web/src/components/PageWithHero.module.css");
